;bc_js.shop_modal = (function ($) {

    function init() {
        $(window).scroll(scrolling);
//               setTimeout(show, 500);

    }

    function show(){
        if (document.cookie.indexOf("shoppopup") === -1 && document.getElementById("hp_newsletter_modal")) {
            document.getElementById("hp_newsletter_modal").hidden = false;
        }
    }
  
  	function setCookie(){
      	let expireDate = new Date();
        let oneDay = expireDate.getTime() + (24 * 60 * 60 * 1000);
        expireDate.setTime(oneDay);
      	document.cookie = "shoppopup=true; path=/; Secure; SameSite=Strict;expires=" + expireDate.toUTCString();
  	}

    function closeModal() {
        $(".modal-backdrop").remove();
      	setCookie();
        
    }

    function scrolling() {
            if (this.oldScroll < this.scrollY+50) {
                console.log(document.cookie.indexOf("shoppopup"))
                if (document.cookie.indexOf("shoppopup") === -1 && document.getElementById("hp_newsletter_modal")) {
                    document.getElementById("hp_newsletter_modal").hidden = false;
                }
            }
        this.oldScroll = this.scrollY;
    }

 	window.onclick = function (e) {

        e = e || window.event;
        var target = e.target || e.srcElement,
            text = target.textContent || target.innerText;
        if (target.id === "modal-block") {
            closeModal()
        }
      	else if (target.id === "close_span") {
            closeModal()
        }
        else if (text === "Jetzt nicht"){
            closeModal()
        }
        else if (target.id === "id_submit_newsletter"){
          setCookie();
          window.location.href = $("#hp_newsletter_modal a").attr('href');
        }
         else if (target.id === "id_image_click"){
          setCookie();
          window.location.href = $("#hp_newsletter_modal a").attr('href');
        }
    };
  
  
  return {
        init: init
    };

})(jQuery);

$(document).ready(function () {
    bc_js.shop_modal.init();
});
